const componentConfig = {
	label: {
		color: 'var(--color-global-black)',
		size: '1',
		tag: 'label',
		type: 'paragraph',
	},
	srLabel: {
		className: 'fuse-radio__sr-label',
	},
};

const inputHeight = '24px';
const inputWidth = '24px';

const stylesConfig = {
	input: {
		height: `calc(${inputHeight} - var(--border-width-s))`, // offset height by outline width
		width: `calc(${inputWidth} - var(--border-width-s))`, // offset width by outline width
	},
	radioLabelBefore: {
		height: inputHeight,
		width: inputWidth,
	},
};

export { componentConfig, stylesConfig };
